export default "__VITE_ASSET__DGxJNB19__"